import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import styled from "@mui/material/styles/styled";
import { useHistory } from "react-router-dom";
import { Button, MenuItem, Popover } from "@mui/material";
import { ActionButton } from "fe-common/ui/buttons/actionButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { getCurrentUserEmail } from "@kahunmedical/user-management";

//region [[ Styles ]]

const AccountCircleStyled = styled(AccountCircle)({
  color: KahunColorMap.Primary,
});

const ArrowDropDownIconStyled = styled(ArrowDropDownIcon)({
  color: KahunColorMap.Primary,
});

const UserProfileButtonStyled = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const UserText = styled("div")({
  fontSize: 14,
  fontWeight: "normal",
  marginRight: 8,
  lineHeight: 1.08,
  textAlign: "right",
  color: KahunColorMap.Primary,
  textTransform: "none",
});

const UsernameLoginWidgetView = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface UsernameLoginWidgetProps {
  disableUserMenu?: boolean;
  onLoginClicked?: () => void;
  onLogoutClicked?: () => void;
  isUserLoggedIn?: boolean;
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const UsernameLoginWidget = ({ ...props }: UsernameLoginWidgetProps) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [userName, setUserName] = useState(null);
  const history = useHistory();

  useEffect(() => {
    getCurrentUserEmail().then((userName) => {
      setUserName(userName);
    });
  }, []);
  const handleUserMenuClicked = (event: React.MouseEvent<HTMLElement>) => {
    if (props.disableUserMenu) return;
    setMenuAnchor(event.currentTarget);
  };

  const handleClose = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setMenuAnchor(null);
    },
    [],
  );

  const goToLogin = () => {
    props.onLoginClicked && props.onLoginClicked();
    setMenuAnchor(null);
  };

  const handleLogout = () => {
    props.onLogoutClicked && props.onLogoutClicked();
    setMenuAnchor(null);
  };

  const renderUserMenu = () => {
    return (
      <Popover
        id="menu-appbar"
        anchorEl={menuAnchor}
        keepMounted
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={!!menuAnchor}
        onClose={handleClose}
        className={props.className}
      >
        <MenuItem className="logout-link" onClick={handleLogout}>
          Log Out
        </MenuItem>
      </Popover>
    );
  };

  const renderUserSection = () => {
    return (
      <>
        <Button
          aria-label="user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleUserMenuClicked}
          color="inherit"
          disabled={props.disableUserMenu}
        >
          <UserProfileButtonStyled>
            <UserText className={"user-name-label"}>{userName}</UserText>
            <AccountCircleStyled />
            {!props.disableUserMenu && <ArrowDropDownIconStyled />}
          </UserProfileButtonStyled>
        </Button>
        {renderUserMenu()}
      </>
    );
  };

  return (
    <UsernameLoginWidgetView>
      {!props.isUserLoggedIn && (
        <ActionButton
          onClick={goToLogin}
          label={"Sign In"}
          primary={"true"}
          className={"widget-action-button"}
        />
      )}
      {props.isUserLoggedIn && renderUserSection()}
    </UsernameLoginWidgetView>
  );
};
